import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Sidebar from "../../../components/sidebar/sidebar";
import styles from "./side-menu.module.scss";
const SideMenu = () => {
    return (_jsx(_Fragment, { children: _jsx("div", Object.assign({ className: `${styles.wrapper} d-none d-sm-block` }, { children: _jsx(Sidebar, {}) })) }));
};
export default SideMenu;
